<template>
  <div>
    <hi-cell title="申请单号：" :value="headInfo.applyCode"></hi-cell>
    <hi-cell title="采购组织：" :value="headInfo.purorgName || headInfo.purorgId"></hi-cell>
    <hi-cell title="供应商：" :value="headInfo.suppName"></hi-cell>
    <hi-cell title="原因分类：" :value="headInfo.reasonType" :options="reasonTypeOptions"></hi-cell>
    <hi-cell title="调整说明：" :value="headInfo.remark"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'DeliveryAdvanceApplyBaseInfo',
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    reasonTypeOptions() {
      return this.$store.getters.dicts.advance_reason_type
    }
  }
}
</script>
